import React from 'react';
import { motion } from 'framer-motion';
import { Phone, FileQuestion, Calendar } from 'lucide-react';

const steps = [
  {
    number: '1',
    icon: Phone,
    title: 'It Answers & Texts',
    description: 'Whether it is a 2 AM emergency call or a text inquiry from your website, the AI responds instantly in a professional, friendly voice.'
  },
  {
    number: '2',
    icon: FileQuestion,
    title: 'It Qualifies & Quotes',
    description: 'The AI asks the right questions: "What is the zip code?" "Is it an emergency?" "What brand is the unit?" It filters out the tire-kickers and identifies the high-ticket jobs.'
  },
  {
    number: '3',
    icon: Calendar,
    title: 'It Books the Job',
    description: 'Integration is seamless. The AI checks your real-time availability in ServiceTitan, Jobber, or Housecall Pro and puts the job right on your dispatch board.'
  }
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 sm:py-32 bg-gradient-to-b from-[#050505] to-[#0F0F13]">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-headline font-bold text-[#F4F4F5] mb-4">
            Your New Most Productive Employee.
          </h2>
          <p className="text-lg text-[#A1A1AA] font-body max-w-3xl mx-auto italic">
            Forget code. Forget complexity. We plug into your existing business in 24 hours.
          </p>
        </motion.div>

        <div className="space-y-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="flex gap-6 items-start"
            >
              <div className="flex-shrink-0">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#00E599] to-[#00D4FF] flex items-center justify-center">
                  <span className="text-2xl font-headline font-bold text-[#050505]">{step.number}</span>
                </div>
              </div>
              
              <div className="flex-1 glass p-8 rounded-xl">
                <div className="flex items-center gap-4 mb-4">
                  <step.icon className="w-8 h-8 text-[#00E599]" />
                  <h3 className="text-2xl font-headline font-bold text-[#F4F4F5]">{step.title}</h3>
                </div>
                <p className="text-[#A1A1AA] font-body leading-relaxed text-lg">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
